import { APP_CONFIG } from "../config/app.config";

const BASE = APP_CONFIG.apiBaseUrl;

/** Erreur HTTP typée — porte le status pour permettre un traitement spécifique (ex. 401) sans parser le message. */
export class ApiError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

function buildHeaders(init?: RequestInit): Record<string, string> {
  const extra = (init?.headers as Record<string, string> | undefined) ?? {};
  // N'ajoute Content-Type: application/json que si la requête a un body
  // (les DELETE/GET sans body doivent rester sans Content-Type pour éviter
  // l'erreur Fastify "Body cannot be empty when content-type is set to application/json")
  return init?.body != null
    ? { "Content-Type": "application/json", ...extra }
    : extra;
}

/** Wrapper HTTP standard : lance une exception typée si la réponse n'est pas ok. */
export async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${path}`, { ...init, headers: buildHeaders(init) });
  if (!res.ok) {
    const body = await res.text().catch(() => res.statusText);
    throw new ApiError(res.status, `API ${res.status}: ${body}`);
  }
  return res.json() as Promise<T>;
}

/** Variante qui retourne null sur 404 (ex. : rôle non encore assigné). */
export async function requestOptional<T>(path: string, init?: RequestInit): Promise<T | null> {
  const res = await fetch(`${BASE}${path}`, { ...init, headers: buildHeaders(init) });
  if (res.status === 404) return null;
  if (!res.ok) {
    const body = await res.text().catch(() => res.statusText);
    throw new ApiError(res.status, `API ${res.status}: ${body}`);
  }
  return res.json() as Promise<T>;
}
